import * as DigitalAssetApi from '../api/DigitalAssetApi';
import {convertToReadUrl} from '../api/DigitalAssetApi';
import {addCustomCoverImage, mkImageSelection} from '../ducks/coverPageImages';
import * as ImageResizer from '../lib/ImageResizer';
import {updatePropertyPreferences} from 'api/propertyPreferences';
import {filenameFromUrl} from '../lib/StringUtils';
import {updatePreferences} from './preferences';

export function addPersistedCoverImage({dispatch, reportType, imageUri, type, propertyId}) {
  dispatch(addCustomCoverImage({imageUri, type, propertyId}));

  let fileName = filenameFromUrl(imageUri);
  if (type === 'property') {
    updatePropertyPreferences(propertyId, {
      [`coverPageImages.custom.${fileName}`]: `property@${imageUri}`,
    });
  } else {
    dispatch(updatePreferences({
      [`coverPageImages.custom.${fileName}`]: `lifestyle@${imageUri}`,
    }, reportType));
  }
}

export function mkPersistedCoverImageSelection({dispatch, reportType, imageUri, type, propertyId, zoom, x, y}) {
  dispatch(mkImageSelection({imageUri, reportType, type, zoom, x, y}));

  const specificPreference = {
    type,
    imageUri: imageUri || null,
    zoom: zoom || 1.0,
    x: x || 0,
    y: y || 0,
  };

  if (type === 'property') {
    const generalPreference = {
      type,
      imageUri: imageUri ? 'default' : null,
    };

    dispatch(updatePreferences({
      'coverPageImages.selection': JSON.stringify(generalPreference),
    }, reportType));

    if (propertyId) {
      updatePropertyPreferences(propertyId, {
        [`coverPageImages.selection.${reportType}`]: JSON.stringify(specificPreference),
      });
    }
  } else {
    dispatch(updatePreferences({
      'coverPageImages.selection': JSON.stringify(specificPreference),
    }, reportType));
    updatePropertyPreferences(propertyId, {
      [`coverPageImages.selection.${reportType}`]: null,
    });
  }
}

export function addCoverImage({type, file, callback}) {
  return async (dispatch, getState) => {
    const {reportType: {value: reportType}, propertyDetail: {propertyId}} = getState();
    const resizedFile = await ImageResizer.resize(file);
    const {data: {url}} = await DigitalAssetApi.uploadDigitalAsset({
      file: resizedFile,
      source: 'upload-cover-image',
      propertyId,
    });
    const imageUri = convertToReadUrl(url);

    addPersistedCoverImage({dispatch, imageUri, propertyId, reportType, type});
    callback && callback(imageUri);
  };
}